import { Injectable } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Injectable({ providedIn: 'root' })
export class TooltipService {
  private tooltipCloseTimer: any;
  private currentTooltip: any;
  private closedByClick: boolean = false;

  handleTooltipVisible(tooltip: NgbTooltip, fromHover = false): void {
    if (this.closedByClick && !fromHover) return;
    this.closedByClick = false;


    this.resetCurrentTooltip();

    this.currentTooltip = tooltip;

    clearTimeout(this.tooltipCloseTimer);
    tooltip.open();

    setTimeout(() => {
      const tooltipElements = document.querySelectorAll('ngb-tooltip-window');
      if (tooltipElements.length > 0) {
        for (let i = 0; i < tooltipElements.length; i++) {
          tooltipElements[i].addEventListener('mouseleave', () => {
            this.handleTooltipHiddenImmediate(this.currentTooltip);
          });
          tooltipElements[i].addEventListener('mouseenter', () => {
            clearTimeout(this.tooltipCloseTimer);
          });
        }
      }
    });
  }

  handleTooltipHidden(tooltip: NgbTooltip): void {
    this.tooltipCloseTimer = setTimeout(() => {
      const tooltipElements = document.querySelectorAll('ngb-tooltip-window');
      for (let i = 0; i < tooltipElements.length; i++) {
        if (tooltipElements[i] && tooltipElements[i].matches(':hover')) {
          return;
        }
      }

      tooltip.close();
    }, 1000);
  }

  handleTooltipHiddenImmediate(tooltip: NgbTooltip): void {
    this.resetCurrentTooltip();

    clearTimeout(this.tooltipCloseTimer);
    tooltip.close();
  }

  handleTooltipOnClick() {
    this.closedByClick = true;
    this.resetCurrentTooltip();

    clearTimeout(this.tooltipCloseTimer);

    const tooltipElements = document.querySelectorAll('ngb-tooltip-window');
    if (tooltipElements.length > 0) {
      for (let i = 0; i < tooltipElements.length; i++) {
        tooltipElements[i].remove();
      }
    }
  }

  private resetCurrentTooltip() {
    if (this.currentTooltip) {
      this.currentTooltip.close();
    }
  }
}
